import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { hexToRgba } from "src/utils/colors";
import LeftArrow from "src/img/left-arrow.png";
import RightArrow from "src/img/right-arrow.png";
import FilteredPngStack from "./FilteredPngStack";
import {
    MobilePreviewArrowButton,
    MobilePreviewArrowImage,
    MobilePreviewDot,
    MobilePreviewHeading
} from "src/components";
import { Screens } from "../../components/Enums";
import { AdFormContext } from "../AdFormContext";

const FlexContainer = styled.div`
    display: flex;
    flex-direction: ${p => p.direction || "row"};
    align-items: center;
    @media (max-width: 600px) {
        width: 100%;
        overflow-x: auto;
    }
`;

const WidthContainer = styled.div`
    box-sizing: ${p => p.boxSizing};
    display: flex;
    height: ${p => p.height || "100%"};
    width: ${p => p.width};
    align-self: center;
    align-items: center;
    justify-content: center;
    flex-direction: ${p => p.direction};
    margin-top: ${p => p.marginTop};
    min-height: ${p => p.minHeight};
    padding: ${p => p.padding};
    position: ${p => p.position};
`;

/**
 * @param {int} currentScreen
 * @param {int[]} screenIds
 * @return {MobilePreviewDot[]}
 */
const renderDotsForSlides = (currentScreen, screenIds) => {
    return screenIds.map((id, index) =>
        <MobilePreviewDot key={index} isHighlighted={id === currentScreen} />
    );
};

const ImageSlider = (props) => {
    const { imageWidth, companyColors, tempLogoUrl, assetLogoUrl, getLabelForPreview } = props;
    const { formVerticalAssetContext } = useContext(AdFormContext);
    const [currentScreen, setCurrentScreen] = useState(Screens.QUOTES);
    const screenIds = [ Screens.QUOTES, Screens.FULLSCREEN_QUOTE, Screens.FULLSCREEN_VERTICAL_QUOTE, Screens.NOTICEBOARD ];
    const dots = renderDotsForSlides(currentScreen, screenIds);

    const getSlidesForScreen = () => {
        return [Screens.QUOTES, Screens.FULLSCREEN_QUOTE, Screens.FULLSCREEN_VERTICAL_QUOTE, Screens.NOTICEBOARD];
    };

    useEffect(() => {
        if (formVerticalAssetContext) {
            setCurrentScreen(Screens.FULLSCREEN_VERTICAL_QUOTE);
        }
    }, [formVerticalAssetContext]);

    const leftScreen = () => {
        const screenIds = getSlidesForScreen(currentScreen);
        const lastScreenIndex = screenIds.length - 1;

        if (currentScreen <= 0) {
            setCurrentScreen(lastScreenIndex);
        } else {
            setCurrentScreen(currentScreen - 1);
        }
    };

    const rightScreen = () => {
        const screenIds = getSlidesForScreen(currentScreen);
        const lastScreenIndex = screenIds.length - 1;

        if (currentScreen < lastScreenIndex) {
            setCurrentScreen(currentScreen + 1);
        } else {
            setCurrentScreen(0);
        }
    };

    const buildColourPalette = () => {
        return {
            primaryColor: hexToRgba(companyColors.primaryColor),
            secondaryColor: hexToRgba(companyColors.secondaryColor),
            backgroundColor: hexToRgba(companyColors.backgroundColor)
        };
    };

    return (
        <FlexContainer>
            <WidthContainer>
                <MobilePreviewArrowButton type="button" margin="0 1rem 0 0" onClick={leftScreen} aria-label="Previous preview screen">
                    <MobilePreviewArrowImage src={LeftArrow} alt="" aria-hidden="true" />
                </MobilePreviewArrowButton>
            </WidthContainer>

            <div>
                <MobilePreviewHeading size="16px">
                    {getLabelForPreview(currentScreen)}
                </MobilePreviewHeading>
                {/* Images container */}
                <WidthContainer width={ imageWidth || "100%" } direction="column">
                    <WidthContainer width={"302px"} height={"614px"} direction="column" padding="40px"
                        boxSizing="border-box" position="relative" minHeight="500px">

                        <FilteredPngStack
                            margin={"auto"}
                            colourPalette={buildColourPalette()}
                            currentScreen={currentScreen}
                            logoUrl={tempLogoUrl ? tempLogoUrl : assetLogoUrl}
                        />
                    </WidthContainer>
                    {/* Displayed dots below images*/}
                    <WidthContainer width="100%" height="auto" boxSizing="border-box" padding="8px">
                        <WidthContainer direction="row" width="100%">
                            {dots}
                        </WidthContainer>
                    </WidthContainer>
                </WidthContainer>
            </div>

            <WidthContainer>
                <MobilePreviewArrowButton type="button" margin="0 0 0 1rem" onClick={rightScreen} aria-label="Next preview screen">
                    <MobilePreviewArrowImage src={RightArrow} alt="" aria-hidden="true" />
                </MobilePreviewArrowButton>
            </WidthContainer>
        </FlexContainer>
    );
};

export default ImageSlider;
